import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStores } from "@hooks";
import { observer } from "mobx-react";
import { notifications } from "@paths";
import { getNewNotificationsQuery } from "@query";
import { universalDateParser } from "@utils";
import { ClearButton, PopMenu } from "@components";
import { Badge, Divider, Grid, IconButton } from "@material-ui/core";
import { NotificationItem } from "@components/AppToolBar/components";
import { ArrowRight } from "@assets";
import { Notifications, NotificationsNone } from "@material-ui/icons";
import useStyle from "./MenuNotifications.style";

export const MenuNotifications = observer(() => {
  const { messageStore } = useStores();
  const { t } = useTranslation();
  const classes = useStyle();

  const [anchorEl, setAnchorEl] = useState(null);
  const [visible, show] = useState(false);

  const { newMessages } = messageStore;

  const loadMessages = async () => {
    const results = await getNewNotificationsQuery();
    messageStore.setNewMessages(results);
  };

  useEffect(() => {
    loadMessages();
  }, []);

  return (
    <>
      <IconButton
        className="p-1"
        ref={setAnchorEl}
        onClick={() => show(!visible)}
        aria-label="Show notifications"
      >
        {newMessages && newMessages.length ? (
          <Badge
            badgeContent={newMessages && newMessages.length}
            overlap="circular"
            aria-label="new messages badge"
            className={classes.badge}
            max={9}
          >
            <Notifications />
          </Badge>
        ) : (
          <NotificationsNone />
        )}
      </IconButton>
      <PopMenu
        show={visible}
        anchor={anchorEl}
        onClickAway={() => show(false)}
        style={{ width: 395, minHeight: 0 }}
      >
        <Grid
          item container
          className="w-full overflow-auto"
          style={{ maxHeight: 266 }}
        >
          {newMessages && newMessages.length ? (
            <div className={classes.messageContainer}>
              {newMessages.map((mes) => {
                const { createdAt, ...rest } = mes;
                const parsedDate = new Date(
                  universalDateParser(createdAt).getTime() -
                    new Date().getTimezoneOffset() * 1000 * 60
                );
  
                return (
                  <NotificationItem
                    key={mes.id}
                    id={mes.id}
                    date={parsedDate}
                    {...rest}
                  />
                );
              })}
            </div>
          ) : (
            <p className={classes.noMessages}>{t("notifications.none")}</p>
          )}
          <Grid item container className={classes.seeAllButtonContainer}>
            <Divider />
            <ClearButton
              className={classes.seeAllButton}
              icon={<ArrowRight />}
              to={notifications}
              onClick={() => show(false)}
            >
              {t("notifications.older")}
            </ClearButton>
          </Grid>
        </Grid>
      </PopMenu>
    </>
  );
});
